module.exports = __webpack_public_path__ + "static/media/best-burger-ever-burger-mobile-en.68fc4294.jpg";